import { Controller } from 'stimulus';
import { getCLS, getFID, getLCP } from 'web-vitals';
import universalTracking from '../tracking/universalTracking';
import delegatedEventListener from '../helpers/delegatedEventListener';

class Tracking extends Controller {
  // eslint-disable-next-line class-methods-use-this
  connect() {
    Tracking.trackTiming();
    Tracking.trackLinks();
  }

  static trackLinks() {
    delegatedEventListener('click', 'a', document, ({ target }) => {
      if (target.matches('a[href^="tel:"]')) {
        universalTracking.event('Phone', 'click', target.href);
        return;
      }

      if (target.matches('a[href^="mailto:"]')) {
        universalTracking.event('Mail', 'click', target.href);
        return;
      }

      if (
        target.href.indexOf(window.location.host) <= 0
        && target.href.match(/^http/i)
      ) {
        universalTracking.event('Outbound', 'click', target.href);
      }
    });
  }

  static trackTiming() {
    getCLS(this.measureTiming);
    getFID(this.measureTiming);
    getLCP(this.measureTiming);
  }

  static measureTiming({ name, delta, id }) {
    if (typeof window.gtag === 'undefined') {
      return;
    }

    window.gtag('event', name, {
      event_category: 'Web Vitals',
      event_label: id,
      value: Math.round(name === 'CLS' ? delta * 1000 : delta),
      non_interaction: true,
    });
  }
}

Tracking.targets = [
  //
];

export default Tracking;
